import { PlatformApi } from '~/services/api/platform'

export class FileService extends PlatformApi {
  async getSignedKey(fileData) {
    const request = await this.post(`/file/signed-url`, fileData)

    return request.response.data
  }

  async deleteFile(fileId, onBehalfOfUserId) {
    await this.delete(`/file/${fileId}`, { onBehalfOfUserId })
  }

  async getUserFiles(userId, category) {
    const request = await this.get(`/file/user/${userId}/${category}`)

    return request.response.data
  }
}
